import { makeReadContract } from '@/utils/wagmi/makeOperations'
import { abi } from '@/abi/Pepper'
import { usePepperContractAddress } from './usePepperContract'

export const useReadPepperContract = makeReadContract(abi, usePepperContractAddress)
